export default __webpack_public_path__ + "static/media/16.ae27ec13.png";